<!--
Program: Approval Sample List
Author: SDL
Description: Approval Sample List
-->
<template>
  <div class="modal-dialog">
    <div class="modal_content login_extension_wrap">
      <!-- contents -->
      <div class="modal_header">
        <h5>{{ $t('cop.login-extension.title') }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')" />
      </div>
      <div class="modal_body">
        <div class="extension_wrap">
          <div class="time">
            <p>
              <strong>{{ remainMin }}</strong><span>{{ $t('cop.login-extension.minute') }}</span>
              <strong>{{ remainSec }}</strong><span>{{ $t('cop.login-extension.second') }}</span>
            </p>
            <p>
              {{ $t('cop.login-extension.message.progress-bar') }}
            </p>
          </div>
          <div class="ext_prog"><span :style="{ width:`${100-remainTime/6000}%` }"></span></div>
          <div class="ext_msg" v-html=" $t('cop.login-extension.message.information')">
          </div>
        </div>
      </div>
      <div class="modal_footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">
          {{ $t('sdl.common.label.cancel') }}
        </button>
        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="extendLogin">
          {{ $t('cop.login-extension.message.extend-button') }}
        </button>
      </div>
    </div>
    <!-- // contents -->
  </div>
</template>

<script>
import SDLUtil from '@/utils/SDLUtil';
import axios from "axios";
import { mapGetters } from 'vuex';
import { getWebClientSocket } from '@/service/webClientService';

export default {
  data() {
    return {
      refreshToken: localStorage.getItem('refreshToken'),
      refreshExp: 0,
      now: Date.now(),
    };
  },
  computed: {
    remainTime() {
      return this.refreshExp - this.now;
    },
    remainSec() {
      return Math.floor((this.remainTime / 1000) % 60);
    },
    remainMin() {
      return Math.floor((this.remainTime / 1000) / 60);
    },
    ...mapGetters({
      webClientConnectionState: 'getWebClientSocketConnectionState',
    }),
  },
  watch: {
    remainTime() {
      if (this.remainTime < 0) {
        this.$router.push(`${this.$context}/logout`);
        this.$emit('close');
      }
    },
  },
  methods: {
    async extendLogin() {
      await axios
        .put(`${SDLUtil.API_URL}/auth/users/refresh-token`)
        .then(({ data }) => {
          localStorage.setItem('refreshToken', data.jwtToken);
          axios.defaults.headers.common['x-auth-refresh-token'] = data.jwtToken;
          this.$emit('close');
        });
      await this.extendWebClientLogin();
    },
    async extendWebClientLogin() {
      console.log(`WebClient Connection: ${this.webClientConnectionState}`);
      if (this.webClientConnectionState) await getWebClientSocket(this);
    }
  },
  created() {
    setInterval(() => {
      this.now = Date.now();
    }, 1000);
  },
  mounted() {
    const refreshUser = SDLUtil.parseJwt(this.refreshToken);
    this.refreshExp = refreshUser.exp * 1000;

  },
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/common/popup/LoginExtensionPopup.vue